export const getTimeTakenInSeconds = (answers) => {
	const arr = Array.isArray(answers) ? answers : [];

	const found = arr.find(
		(item) => item.metaData === 'totalTimeTakenInSeconds'
	);

	return found?.value ?? null;
};
